import * as React from 'react'
import Image from 'next/image'
import { LandingPageButton } from '../LandingPageButton'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

type Props = {
  title: string
}

import nubrakesWhiteLogo from '../../../public/img/nubrakes-logo-no-text.svg'

export const ScheduleServiceCallToActionSection: React.FC<Props> = ({ title }) => (
  <GraySection className="text-center">
    <Container>
      <div>
        <div className="pb-4">
          <Image className="mx-auto" src={nubrakesWhiteLogo} alt={'NuBrakes Logo'} />
        </div>
        <h2 className="title">{title}</h2>
      </div>
      <div style={{ paddingTop: '5%' }}>
        <LandingPageButton buttonText={'Get A Free Brake Service Estimate'} />
      </div>
    </Container>
  </GraySection>
)
